var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.queries),function(query,idx){return _c('Query',{key:query.id,attrs:{"query":query,"types":_vm.types,"grouped-attributes":_vm.groupedAttributes,"idx":idx},on:{"remove":function($event){return _vm.removeQuery(query)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }